import React, { useEffect, useRef, useState } from 'react'
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../../cvp-webgames-core/pre-caching/pre-cache-item';
import { AnimationPage, AnimationPageType } from '../../../cvp-webgames-core/UI/Animation/animation-page';
import { constants } from '../../../misc/constants';
import { BaseConfig } from '../../BaseConfig';
import PopUp1 from '../../general/pop-up1';

import "./initial-window.css"
import { CustomGameDataConfig, CustomGameDataManager, TextHtmlTagType } from '../../../misc/tools';
import Tools from '../../../cvp-webgames-core/Misc/Tools';

class InitialWindowCaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'bg',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/main-menu-bg.png'
			},
			{
				type: PrecacheItemType.Image,
				key: 'enabled',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/accessibility-enabled.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'disabled',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/accessibility-disabled.svg'
			}
		];
	}
}

export const initialWindowCaching = new InitialWindowCaching();

const InitialWindow = (props: InitialWindowConfig) => {
	const [animateOut, setAnimateOut] = useState(false);
	if (!animateOut) {
		localStorage.setItem('isInAccessibilityScreen-bs', '1');
	}

	const [savedData, setSavedData] = useState(null as CustomGameDataConfig);

	if (!savedData) {
		Tools.getSaveData().then((savedData: CustomGameDataManager) => {
			setSavedData(savedData.data);
		});
		return null;
	}

	return (
		<div className={"modal-disable-select initial-window-container"} style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<img className={`initial-window-container-bg${animateOut ? '-animation' : ''}`} src={initialWindowCaching.getItemByKey('bg').src} style={{
				position: 'absolute',
				width: '100%',
				top: '0',
				left: '0'
			}} />
			<PopUp1
				mainMenu={true}
				onUpdateRoot={(r) => {
					props.animation.updateProps({
						page: r.current
					});
				}}
				title={constants.projectTitle}
				rootClass={props.animation.getInitialClass()}
				buttons={[
					{
						imgSrc: initialWindowCaching.getItemByKey('enabled').src,
						width: '95%',
						height: '240px',
						hoverColor: '#bfddff',
						bgColor: undefined,
						buttonText2: (isHovering: boolean) => {
							return (
								<div>
									<h2 className=' black-text header1-text'>Accessibility Features</h2>
									<h3 className=' enabled-text'>ENABLED</h3>
									<p className='black-text'>Choose this option if you need access to the <b>Visible Focus</b> feature.</p>
								</div>
							)
						},
						onClick: () => {
							localStorage.setItem('isInAccessibilityScreen-bs', '0');
							if (savedData.isAnimationsEnabled) {
								setAnimateOut(true);
							}
							props.onClick(true)
						},
						mainMenu: true
					},
					{
						imgSrc: initialWindowCaching.getItemByKey('disabled').src,
						width: '95%',
						height: '240px',
						hoverColor: '#bfddff',
						bgColor: undefined,
						buttonText2: (isHovering: boolean) => {
							return (
								<div>
									<h2 className=' black-text header1-text'>Accessibility Features</h2>
									<h3 className=' disabled-text'>DISABLED</h3>
									<p className='black-text'>If you do not need the <b>Visible Focus</b> feature enabled, then choose this option.</p>
								</div>
							)
						},
						onClick: () => {
							localStorage.setItem('isInAccessibilityScreen-bs', '0');
							if (savedData.isAnimationsEnabled) {
								setAnimateOut(true);
							}
							props.onClick(false)
						},
						mainMenu: true
					}
				]}
				onRenderContent={() => {
					return (
						<h1 style={{ textAlign: 'center', color: 'white' }} className='center-element-horizontal'>
							How would you like to train today?
						</h1>);
				}}
				onRenderContent2={() => {
					return (
						<p style={{ textAlign: 'center', color: 'white' }} className='center-element-horizontal'>
							You can change this option later in the <b>Settings Menu</b> if you choose.
						</p>);
				}}></PopUp1>
		</div>
	);

};

export interface InitialWindowConfig extends BaseConfig {
	animation: AnimationPage;
	onClick: (isAccessibilityEnabled: boolean) => void;
}

export default InitialWindow;
